/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {PeerPracticeSession} from "../model/peer-practice-session";
import {SetParticipantStateForCurrentRunRequest} from "../model/set-participant-state-for-current-run-request";
import {SetStationStateForCurrentRunRequest} from "../model/set-station-state-for-current-run-request";

@Injectable({
    providedIn: "root",
})
export class SimPeerPracticeService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Get the current or upcoming Peer Practice Session for the user
 */ 

    public getPeerPracticeSessionForUser() {
        return super.get<string>(`/api/PeerPractice/GetPeerPracticeSessionForUser`, );
    }
/**
 * Set the Participant State for the current Run
 */ 

    public setParticipantStateForCurrentRun(request: SetParticipantStateForCurrentRunRequest) {
        return super.post<void>(`/api/PeerPractice/SetParticipantStateForCurrentRun`, request);
    }
/**
 * Set the Station State for the current Run
 */ 

    public setStationStateForCurrentRun(request: SetStationStateForCurrentRunRequest) {
        return super.post<void>(`/api/PeerPractice/SetStationStateForCurrentRun`, request);
    }
/**
 * Transition the current Run to the next phase
 */ 

    public transitionToNextPhase(sessionId: string) {
        return super.post<PeerPracticeSession>(`/api/PeerPractice/TransitionToNextPhase/${encodeURIComponent(sessionId)}/transition`, {});
    }
}